import { FormHelperText, styled } from "@mui/material";

const StyledFormHelperText = styled(FormHelperText)`
  && {
    color: ${(props) => props.theme.wsc.palette.warning[300]};
    font-size: ${(props) => props.theme.wsc.typography.body3.fontSize};
    font-weight: ${(props) => props.theme.wsc.typography.body3.fontWeight};
    margin-top: ${(props) => props.theme.wsc.spacing[0]};
    margin-bottom: 0;
  }
`;
export default StyledFormHelperText;
